










































import { VaultItem } from "vaultifier";
import Vue, { PropType } from "vue";
import 'zingchart/es6';
//@ts-expect-error zingchart-vue does not have types
import zingchartVue from 'zingchart-vue';
import { Evaluator } from '../utils/evaluator';

interface Row {
  expression: string;
}

interface Scale {
  labels: string[],
}

interface ChartData {
  scaleX: Scale,
  type: string
  series: {
    values: any[],
  }[],
}

interface Data {
  rows: Row[],
  labels: string[],
  scaleXExpression: string,
  chartData: ChartData | undefined,
}

export default Vue.extend({
  components: {
    zingchart: zingchartVue,
  },
  props: {
    items: Array as PropType<VaultItem[]>,
  },
  data: (): Data => ({
    rows: [{ expression: '' }],
    labels: [],
    scaleXExpression: '',
    chartData: undefined,
  }),
  computed: {
    canRemoveRow() {
      return this.rows.length > 1;
    },
  },
  methods: {
    addRow(idx: number) {
      this.rows.splice(idx + 1, 0, {
        expression: '',
      })
    },
    removeRow(idx: number) {
      this.rows.splice(idx, 1);
    },
    computeChartData(): ChartData | undefined {
      if (!this.items || this.items.length === 0)
        return;

      const data: ChartData = {
        type: 'area',
        scaleX: {
          labels: [],
        },
        series: [],
      }

      for (let j = 0, size = this.rows.length; j < size; j++) {
        const row = this.rows[j];

        if (!row.expression)
          continue;

        const series: any[] = [];

        for (let i = 0, size = this.items.length; i < size; i++) {
          const item = this.items[i];

          // only in first loop we populate labels
          if (j === 0) {
            data.scaleX.labels.push(Evaluator.evalTypeAgnostic(this.scaleXExpression, item) || (i + 1));
          }

          const value = Evaluator.evalTypeAgnostic(row.expression, item);

          if (value !== undefined && value !== null) {
            series.push(value);
          }
        }

        data.series.push({ values: series });
      }

      this.chartData = data.series.length === 0 ? undefined : data;
        return;
    },
  },
});
